export default class PayExemptionFeeAmount {
    // CON-451: Guid de ProcessConfigurationPayExemption, ya no el bit-flag. `amount` es null cuando
    // el proceso no tiene pago online: el descuento está ofertado pero sin importe asociado.
    private _payExemptionType: string;
    private _amount: number | null;

    public constructor(data: any) {
        this._payExemptionType = data.payExemptionType;
        this._amount = data.amount;
    }

    public get payExemptionType() {
        return this._payExemptionType;
    }

    public get amount() {
        return this._amount;
    }
}
